import { Sx, TextProps } from '@mantine/core';

/**
 * Merges the base typography sx styles with caller-provided sx overrides.
 */
export default function mergeTextSx(baseSx: Sx, sx?: TextProps['sx']): (Sx | undefined)[] {
  return Array.isArray(sx) ? [baseSx, ...sx] : [baseSx, sx];
}
